import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  float: {
    position: "absolute",
    right: 0,
    bottom: 0,
    height: spacing(6),
    flexDirection: "row",
  },
  fade: {
    height: spacing(6),
    width: spacing(10),
  },
  readMoreText: {
    height: spacing(6),
    lineHeight: spacing(6),
  },
}));

export default stylesheet;
